import AdminAlert from "./AdminAlert"

export default AdminAlert
